enum UpcomingVariant {
  UP_TO_DATE_AND_UPCOMING,
  UPCOMING,
  UP_TO_DATE,
}

export default UpcomingVariant;
